import styled from 'styled-components';
import Skeleton from '@material-ui/lab/Skeleton';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const ChannelSkeleton = styled(Skeleton)`
  margin: ${p => p.margin ?? '12px'};
  height: 95px;
  transform: none;

  ${breakpoints.down('sm')} {
    margin: 5px;
    height: 75px;
  }
`;

export default ChannelSkeleton;
